export const isNotificationCenterVisible = ({ notificationCenter }) => notificationCenter.isVisible;

export const getNotificationCenterNewCount = ({ notificationCenter }) => notificationCenter.newNotificationsCount;
